import PropTypes from "prop-types"
import OPTooltip from "components/material/tooltip"

export default function EllipsableItem({ label, value, barWidth }) {
  const clampedWidth = Math.min(100, barWidth)

  return <div data-test-class="compare-table-value" className="ellipsable-item">
    <div className="chart-bar" style={{ width: `${clampedWidth}%` }} />
    <div className="text-overflow-dynamic-container">
      <div className="text-overflow-dynamic-ellipsis"><OPTooltip title={label}>{label}</OPTooltip></div>
    </div>
    <div>{value}</div>
  </div>
}

EllipsableItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  barWidth: PropTypes.number.isRequired,
}
